import script from "./ClientIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientIndex.vue?vue&type=script&setup=true&lang=js"

import "./ClientIndex.vue?vue&type=style&index=0&id=3821ecd3&lang=css"
import "./ClientIndex.vue?vue&type=style&index=1&id=3821ecd3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3821ecd3"]])

export default __exports__